import PropTypes from "prop-types";

import ItemsAutoComplete from "../../components/_customs/ItemsAutoComplete";

ItemAutoComplete.propTypes = {
    onChange: PropTypes.func,
    type: PropTypes.string,
    size: PropTypes.string,
};


export default function ItemAutoComplete({type, onChange, size}) {

    return (
        <ItemsAutoComplete size={'large'} minWidth={'100%'} onChange={onChange}/>
    );
}
